/* HOP (2026-10-21): desktop header = wordmark | menu · badge logo · menu | icons.
   Items before "About" sit left of the logo, "About" and later right of it. The
   middle group (menu + logo + menu) is centred on the page so it lines up with
   the announcement bar. Below 990px the original markup is put back, so the
   mobile header (drawer + centred logo) is untouched. */
(function () {
  var header = document.querySelector('header.header');
  if (!header || header.dataset.hopSplit) return;
  header.dataset.hopSplit = '1';

  var heading = header.querySelector(':scope > .header__heading, :scope > .header__heading-link');
  var nav = header.querySelector(':scope > nav.header__inline-menu');
  var icons = header.querySelector(':scope > .header__icons');
  if (!heading || !nav || !icons) return;
  var ul = nav.querySelector('ul.list-menu--inline');
  if (!ul) return;

  var items = Array.prototype.slice.call(ul.children);
  var splitAt = -1;
  for (var i = 0; i < items.length; i++) {
    var label = items[i].querySelector('.header__menu-item');
    if (label && /^about$/i.test(label.textContent.trim())) { splitAt = i; break; }
  }
  if (splitAt < 1) splitAt = Math.ceil(items.length / 2);
  var rightItems = items.slice(splitAt);

  // Wordmark on the far left, a link home in the same style as the old one.
  var oldMark = heading.querySelector('.hop-wordmark');
  var brand = document.createElement('a');
  brand.href = '/';
  brand.className = 'hop-split__brand link link--text';
  var mark = document.createElement('span');
  mark.className = oldMark ? oldMark.className : 'hop-wordmark';
  mark.textContent = oldMark ? oldMark.textContent.trim() : 'House of Places';
  brand.appendChild(mark);

  var left = document.createElement('div');
  left.className = 'hop-split__left';
  var center = document.createElement('div');
  center.className = 'hop-split__center';
  var right = document.createElement('div');
  right.className = 'hop-split__right';
  var nav2 = document.createElement('nav');
  nav2.className = 'header__inline-menu';
  nav2.setAttribute('aria-label', 'Secondary');
  var ul2 = document.createElement('ul');
  ul2.className = ul.className;
  ul2.setAttribute('role', 'list');
  nav2.appendChild(ul2);

  // Inline search: the field slides out right next to the search icon instead
  // of Dawn's full-width search bar under the header. Desktop only.
  var modalSearch = icons.querySelector('details-modal.header__search');
  var isearch = document.createElement('form');
  isearch.className = 'hop-isearch';
  isearch.action = (window.routes && window.routes.search_url) || '/search';
  isearch.method = 'get';
  isearch.setAttribute('role', 'search');
  isearch.innerHTML =
    '<input type="hidden" name="type" value="product">' +
    '<input class="hop-isearch__input" type="search" name="q" placeholder="Search a city or country" aria-label="Search posters" autocomplete="off">' +
    '<button class="hop-isearch__btn header__icon link focus-inset" type="button" aria-label="Search">' +
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="M20 20l-4.6-4.6"></path></svg>' +
    '</button>';
  var iInput = isearch.querySelector('.hop-isearch__input');
  var iBtn = isearch.querySelector('.hop-isearch__btn');
  var iTimer = null;
  function iOpen(focus) {
    clearTimeout(iTimer);
    isearch.classList.add('is-open');
    if (focus) iInput.focus();
  }
  function iClose() {
    if (iInput.value.trim() || document.activeElement === iInput) return;
    isearch.classList.remove('is-open');
  }
  isearch.addEventListener('mouseenter', function () { iOpen(false); });
  isearch.addEventListener('mouseleave', function () { clearTimeout(iTimer); iTimer = setTimeout(iClose, 400); });
  iInput.addEventListener('blur', function () { iTimer = setTimeout(iClose, 200); });
  iInput.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { iInput.value = ''; iInput.blur(); isearch.classList.remove('is-open'); }
  });
  iBtn.addEventListener('click', function () {
    if (isearch.classList.contains('is-open') && iInput.value.trim()) { isearch.submit(); return; }
    iOpen(true);
  });

  var mq = window.matchMedia('(min-width: 990px)');

  function split() {
    if (header.classList.contains('hop-split')) return;
    if (modalSearch) icons.insertBefore(isearch, modalSearch); else icons.insertBefore(isearch, icons.firstChild);
    rightItems.forEach(function (li) { ul2.appendChild(li); });
    left.appendChild(brand);
    center.appendChild(nav);
    center.appendChild(heading);
    center.appendChild(nav2);
    right.appendChild(icons);
    header.appendChild(left);
    header.appendChild(center);
    header.appendChild(right);
    header.classList.add('hop-split');
  }

  function unsplit() {
    if (!header.classList.contains('hop-split')) return;
    rightItems.forEach(function (li) { ul.appendChild(li); });
    isearch.remove();
    header.appendChild(heading);
    header.appendChild(nav);
    header.appendChild(icons);
    left.remove();
    center.remove();
    right.remove();
    header.classList.remove('hop-split');
  }

  function apply() { mq.matches ? split() : unsplit(); }
  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply);
})();
